"use client";

import { IconType } from "react-icons";
import { FaFacebook } from "react-icons/fa";

interface ButtonProps {
  label: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  outline?: boolean;
  small?: boolean;
  icon?: IconType;
  className?: string;
  type?: "button" | "submit" | "reset";
}

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  disabled,
  outline,
  small,
  icon: Icon,
  type,
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`
        relative
        disabled:opacity-70
        disabled:cursor-not-allowed
        rounded-lg
        hover:opacity-80
        transition
        w-full
        flex
        items-center
        justify-center
        gap-3
        ${outline ? "bg-white" : "bg-emerald-600"}
        ${outline ? "border-black" : "border-emerald-600"}
        ${outline ? "text-black" : "text-white"}
        ${small ? "text-sm" : "text-md"}
        ${small ? "py-1" : "py-3"}
        ${small ? "font-light" : "font-semibold"}
        ${small ? "border-[1px]" : "border-2"}
      `}
    >
      {Icon && (
        <Icon
          size={20}
          color={Icon === FaFacebook ? "#4267B2" : undefined}
          className="flex-shrink-0 ml-3"
        />
      )}
      <span className="flex-1 text-center">{label}</span>
      {/* Spacer invisible para mantener el texto centrado */}
      {Icon && <span className="w-5 flex-shrink-0" />}
    </button>
  );
};

export default Button;
